import { useEffect } from 'react';
import FurnitureShopScreen from '../../../screens/FurnitureShopScreen';
import HouseFurnitureInventoryScreen from '../../../screens/HouseFurnitureInventoryScreen';
import useInterfaceStore from '../../../stores/useInterfaceStore';
import { mapSceneSingleton } from '../../map/mapScene';

interface RoomPanelProps {
  mapObjectId: number;
}

/**
 * The furniture shop / inventory, full screen over the room. The room stays
 * mounted underneath — closing the panel shows it again at once, with nothing
 * reloaded — and does not draw while it is covered.
 */
export default function RoomPanel({ mapObjectId }: RoomPanelProps) {
  const panel = useInterfaceStore((s) => s.roomPanel);
  const setRoomPanel = useInterfaceStore((s) => s.setRoomPanel);
  const open = panel !== null;

  useEffect(() => {
    const app = mapSceneSingleton.app;
    if (!open || !app) return;
    app.ticker.stop();
    return () => {
      // Leaving the room altogether (or the page): the room's own teardown owns the ticker.
      if (useInterfaceStore.getState().currentView === 'room' && app.canvas.isConnected) app.ticker.start();
    };
  }, [open]);

  if (!open) return null;
  const close = () => setRoomPanel(null);
  return (
    <div className="fixed inset-0 z-[2000]" data-testid={`room-panel-${panel}`}>
      {panel === 'shop'
        ? <FurnitureShopScreen mapObjectId={mapObjectId} onClose={close} />
        : <HouseFurnitureInventoryScreen mapObjectId={mapObjectId} onClose={close} />}
    </div>
  );
}
